module.exports = __webpack_public_path__ + "img/transportVoucher.4325626c.jpg";